import NoOffer from './NoOffer.vue'

export default NoOffer
